<template>
  <svg class="disclosure-arrow" viewBox="0 0 16 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M0,0L3,0L16,22L3,44L0,44L13,22L0,0Z"/>
  </svg>
</template>